import React, { useEffect, useState, useRef } from "react";
import { Grid, Box, Button, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, Paper, IconButton, TableHead } from "@material-ui/core";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
// styles
import useStyles from "../../../../themes/makeStyles";
import clsx from "clsx";
import moment from "moment";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import PropTypes from "prop-types";
// import { default as Apiservices } from '../../../common'

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(0),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                    <KeyboardArrowRight />
                )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
    table: {
        minWidth: "100%",
        whiteSpace: "",
        td: {

        }
    },
    toobarBgColor: {
        "& .MuiToolbar-regular": {
            background: "#fff",
        },
    },
    container: {
        // maxHeight: "60vh",
        minHeight: "100px",
        overflowY: "hidden",
        "&:hover": {
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "4px",
            },

            /* Track */

            "&::-webkit-scrollbar-track": {
                background: "#fff",
            },

            /* Handle */

            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#d4d8da",
                borderRadius: "20px",
            },

            /* Handle on hover */

            "&::-webkit-scrollbar-thumb:hover": {
                background: "",
            },
        },
    },
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        padding: 8,
    },
    body: {
        fontSize: 14,
        padding: 8,
    },
}))(TableCell);

export default function Table2(props) {
    var classesTwo = useStyles();
    const classes = useStyles2();
    const [page, setPage] = React.useState(0);
    const [array, setArray] = React.useState([
        { invoicedate: "No Data", count: "No Data" },
    ]);
    const [loading, setLoading] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [endDate, setEndDate] = React.useState(null);
    var tableData = [{
        destination: "No Data",
        ir_load_name: "No Data",
        ir_rake_id: "No Data",
        rr_actual_weight: "No Data",
        rr_amount: "No Data",
        rr_chargeable_weight: "No Data",
        rr_date: "No Data",
        rr_no: "No Data",
        rr_punitive: "No Data"
    }]
    var testData = [{
        destination: "test Data 1",
        ir_load_name: "test Data 1",
        ir_rake_id: "test Data 1",
        rr_actual_weight: "test Data 1",
        rr_amount: "test Data 1",
        rr_chargeable_weight: "test Data 1",
        rr_date: "test Data 1",
        rr_no: "test Data 1",
        rr_punitive: "test Data 1"
    }]

    const fetchData = async () => {
        // const response = await Apiservices.tonnageReports();
        if (testData) {
            setArray(testData);
        } else {
            setArray(tableData);
        }
    }

    useEffect(() => {
        const response = fetchData()
    }, []);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, array.length - page * rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // const generateReport = async (details) => {
    //     console.log(details);
    //     let dates = {
    //         start_date: startDate,
    //         end_date: endDate
    //     }
    //     let filename =
    //         "consolidated_reports_" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
    //     let submitResults = await download_consolidated_reports(filename, dates);
    //     console.log(submitResults);
    //     // Apiservices.downloadDashboardJobDetails(startDate, endDate);
    // }

    return (
        <>
            <div>
                {/* <Box py={3}>
                    <Grid container spacing={2} justify="space-between" alignItems="center">
                        <Grid item>
                            <h2 className={classesTwo.mainHeading}>{"Tonnage Report"}</h2>
                        </Grid>
                    </Grid>
                </Box> */}

                <div>
                    <Box py={1}>
                        <TableContainer component={Paper} className={classes.container}>
                            <Table
                                className={classes.table}
                                aria-label="simple table"
                                stickyHeader
                            >
                                {loading ? (
                                    <h1>Skeleton comes here!</h1>
                                ) : (
                                    <>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell colSpan={2} align="center">
                                                    <b>CUMMULATIVE RR VALUE (LTTC)</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>INR (Crs.)</b>
                                                </StyledTableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {/* {(rowsPerPage > 0
                                                ? array.slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                : array
                                            ).map((row, index) => (
                                                
                                            ))} */}
                                            <TableRow>
                                                <TableCell align="center">
                                                    <div>
                                                        <b>SFTO</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_mtd_total_rr_count ?
                                                                <b>{Number(props.item.sfto_mtd_total_rr_count).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_mtd_total_rr_amount ?
                                                                <b>{Number(props.item.sfto_mtd_total_rr_amount).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="center">
                                                    <div>
                                                        <b>GPWIS</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.gpwis_mtd_total_rr_count ?
                                                                <b>{Number(props.item.gpwis_mtd_total_rr_count).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.gpwis_mtd_total_rr_amount ?
                                                                <b>{Number(props.item.gpwis_mtd_total_rr_amount).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                            {/* <TableRow>
                                                <TableCell align="center">
                                                    <div>
                                                        <b>JCAP</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        <b>-</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        <b>-</b>
                                                    </div>
                                                </TableCell>
                                            </TableRow> */}
                                            <TableRow>
                                                <TableCell align="center">
                                                    <div>
                                                        <b>TOTAL</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.gpwis_mtd_total_rr_count && props.item.sfto_mtd_total_rr_count ?
                                                                <b>{Number(props.item.gpwis_mtd_total_rr_count + props.item.sfto_mtd_total_rr_count).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.gpwis_mtd_total_rr_amount && props.item.sfto_mtd_total_rr_amount ?
                                                                <b>{Number(props.item.gpwis_mtd_total_rr_amount + props.item.sfto_mtd_total_rr_amount).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {/* <TableContainer>
                            <TablePagination
                                className={classes.toobarBgColor}
                                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                                component="div"
                                count={array.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: { "aria-label": "rows per page" },
                                    native: true,
                                }}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableContainer> */}
                    </Box>
                </div >
            </div>
        </>
    );
}